const _excluded = ["role", "tabIndex"],
  _excluded2 = ["canDragAndDropColumns", "children"],
  _excluded3 = ["canDragAndDropColumns", "children"];
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.indexOf(n) >= 0) continue;
    t[n] = r[n];
  }
  return t;
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import React, { memo, useCallback, useContext, useRef } from 'react';
import PropTypes from "prop-types";
import { useEuiMemoizedStyles, useGeneratedHtmlId } from '../../../../services';
import { EuiDragDropContext, EuiDroppable, EuiDraggable } from '../../../drag_and_drop';
import { EuiPortal } from '../../../portal';
import { DataGridFocusContext } from '../../utils/focus';
import { euiDataGridStyles } from '../../data_grid.styles';
import { euiDataGridDraggableHeaderStyles } from './draggable_columns.styles';

/**
 * Parent context + EuiDroppable wrapper
 */
export var DroppableColumns = /*#__PURE__*/memo(function (_ref) {
  var columns = _ref.columns,
    switchColumnPos = _ref.switchColumnPos,
    indexOffset = _ref.indexOffset,
    children = _ref.children;
  var styles = useEuiMemoizedStyles(euiDataGridDraggableHeaderStyles);
  var droppableId = useGeneratedHtmlId({
    prefix: 'euiDataGridHeaderDroppable'
  });
  var _useContext = useContext(DataGridFocusContext),
    setFocusedCell = _useContext.setFocusedCell;
  var handleOnDragEnd = useCallback(function (_ref2) {
    var source = _ref2.source,
      destination = _ref2.destination;
    if (!source) return;
    if (destination && destination.index !== source.index) {
      var sourceColumn = columns[source.index - indexOffset];
      var destinationColumn = columns[destination.index - indexOffset];
      if (sourceColumn && destinationColumn) {
        switchColumnPos(sourceColumn.id, destinationColumn.id);
      }
    }
    // Force focus the cell to prevent the datagrid body from become unfocusable, including on drag cancel
    setTimeout(function () {
      var cellToFocus = destination ? destination.index : source.index;
      setFocusedCell([cellToFocus, -1], true);
    });
  }, [columns, indexOffset, switchColumnPos, setFocusedCell]);
  return ___EmotionJSX(EuiDragDropContext, {
    onDragEnd: handleOnDragEnd
  }, ___EmotionJSX(EuiDroppable, {
    droppableId: droppableId,
    direction: "horizontal",
    ignoreContainerClipping: true,
    css: styles.euiDataGridHeaderDroppable,
    "data-test-subj": "euiDataGridHeaderDroppable"
  }, children));
});
DroppableColumns.propTypes = {
  indexOffset: PropTypes.number.isRequired,
  children: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.arrayOf(PropTypes.element.isRequired).isRequired, PropTypes.any.isRequired]).isRequired
};
DroppableColumns.displayName = 'DroppableColumns';

/**
 * Individual EuiDraggable columns
 */
export var DraggableColumn = /*#__PURE__*/memo(function (_ref3) {
  var id = _ref3.id,
    index = _ref3.index,
    gridStyles = _ref3.gridStyles,
    columnResizer = _ref3.columnResizer,
    actionsPopoverToggle = _ref3.actionsPopoverToggle,
    children = _ref3.children;
  var dataGridStyles = useEuiMemoizedStyles(euiDataGridStyles);
  var styles = useEuiMemoizedStyles(euiDataGridDraggableHeaderStyles);
  // Manually re-apply background and border overrides, since
  // the droppable zone sets its own and confuses :first-of-type CSS
  var reapplyCellStyles = [styles[gridStyles.header], index !== 0 && styles.noLeadingBorder];

  // Draggable prevents the cell from receiving focus on click.
  // We manually ensure focus is set on cell mouseDown which
  // also includes setting focus before dragging
  var _useContext2 = useContext(DataGridFocusContext),
    setFocusedCell = _useContext2.setFocusedCell;
  var handleOnMouseDown = useCallback(function (e) {
    var openFocusTraps = document.querySelectorAll('[data-focus-lock-disabled="false"]');
    var validOpenFocusTraps = _toConsumableArray(openFocusTraps).filter(function (focusTrap) {
      return !focusTrap.contains(e.currentTarget);
    } // remove containing focus traps (e.g. modals or flyouts)
    );
    var shouldDispatchEvent = validOpenFocusTraps.some(function (focusTrap) {
      return !!focusTrap &&
      // If there is a focus trap open
      !focusTrap.contains(e.target) &&
      // & if it doesn't contain the target
      e.target !== actionsPopoverToggle;
    } // & we're not closing the actions popover toggle
    );
    if (shouldDispatchEvent) {
      // Trick the focus trap lib into registering an outside click -
      // the drag/drop lib otherwise prevents the event 💀
      document.dispatchEvent(new MouseEvent('mousedown'));
    }
    setTimeout(function () {
      setFocusedCell([index, -1], true);
    });
  }, [setFocusedCell, index, actionsPopoverToggle]);

  // Prevent any other keypresses when dragging
  var isDraggingRef = useRef(false);
  var handleOnKeydown = useCallback(function (e) {
    if (isDraggingRef.current) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, []);

  // UX polish: add a slight animation frame delay to the dragging ref end
  // which prevents re-running the hover animation of column header actions
  var updateDraggingRef = useCallback(function (isDragging) {
    // Only update if the state has changed from before
    if (isDragging !== isDraggingRef.current) {
      if (!isDragging) {
        requestAnimationFrame(function () {
          isDraggingRef.current = false;
        });
      } else {
        isDraggingRef.current = true;
      }
    }
  }, []);
  return ___EmotionJSX("div", {
    css: styles.euiDataGridHeaderCellDraggableWrapper,
    onMouseDown: handleOnMouseDown,
    onKeyDownCapture: handleOnKeydown
  }, columnResizer, ___EmotionJSX(EuiDraggable, {
    draggableId: id,
    className: "euiDataGridHeaderCellDraggable",
    css: styles.euiDataGridHeaderCellDraggable,
    index: index,
    customDragHandle: "custom",
    hasInteractiveChildren: true,
    usePortal: true
  }, function (_ref4, _ref5) {
    var dragHandleProps = _ref4.dragHandleProps;
    var isDragging = _ref5.isDragging,
      mode = _ref5.mode;
    updateDraggingRef(isDragging);
    var _ref6 = dragHandleProps !== null && dragHandleProps !== void 0 ? dragHandleProps : {},
      role = _ref6.role,
      tabIndex = _ref6.tabIndex,
      restDragHandleProps = _objectWithoutProperties(_ref6, _excluded);
    var passedProps = _objectSpread(_objectSpread({}, restDragHandleProps), {}, {
      css: reapplyCellStyles,
      'data-column-moving': isDraggingRef.current || undefined,
      isDragging: isDragging
    });

    // since the cloned content is in a portal outside the datagrid
    // we need to re-add styles to the cell as the scoped styles
    // from the wrapper don't apply
    var draggingStyles = [styles.euiDataGridHeaderCellDraggable,
    // ensure height is maintained while dragging
    dataGridStyles.cellPadding[gridStyles.cellPadding], dataGridStyles.fontSize[gridStyles.fontSize], dataGridStyles.borders[gridStyles.border], mode === 'SNAP' && styles.isKeyboardDragging];
    return isDragging ? ___EmotionJSX("div", {
      css: draggingStyles
    }, ___EmotionJSX(DragOverlay, {
      isDragging: true,
      cursor: "grabbing"
    }), children(passedProps)) : children(passedProps);
  }));
});
DraggableColumn.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  gridStyles: PropTypes.shape({
    /**
       * Size of fonts used within the row and column cells
       * @default m
       */
    fontSize: PropTypes.oneOf(["s", "m", "l"]),
    /**
       * Defines the padding with the row and column cells
       * @default m
       */
    cellPadding: PropTypes.oneOf(["s", "m", "l"]),
    /**
       * Border used for the row and column cells
       * @default all
       */
    border: PropTypes.oneOf(["all", "horizontal", "none"]),
    /**
       * If set to true, rows will alternate zebra striping for clarity
       * @default false
       */
    stripes: PropTypes.bool,
    /**
       * Visual style for the column headers. Recommendation is to use the `underline` style in times when #EuiDataGrid `toolbarVisibility` is set to `false`.
       * @default shade
       */
    header: PropTypes.oneOf(["shade", "underline"]),
    /**
       * Visual style for the column footers.
       * @default overline
       */
    footer: PropTypes.oneOf(["shade", "overline", "striped"]),
    /**
       * If set to true, the footer row will be sticky
       * @default true
       */
    stickyFooter: PropTypes.bool,
    /**
       * Will define what visual style to show on row hover
       * @default hover
       */
    rowHover: PropTypes.oneOf(["highlight", "none"]),
    /**
       * Optionally pass custom classes to highlight or customize certain rows
       */
    rowClasses: PropTypes.shape({}),
    /**
       * Optional callback returning the current `gridStyle` config when changes occur from user input (e.g. toolbar display controls).
       * Can be used for, e.g. storing user `gridStyle` in a local storage object.
       */
    onChange: PropTypes.func
  }).isRequired,
  columnResizer: PropTypes.node,
  actionsPopoverToggle: PropTypes.oneOfType([PropTypes.any.isRequired, PropTypes.oneOf([null])]),
  children: PropTypes.func.isRequired
};
DraggableColumn.displayName = 'DraggableColumn';

/**
 * Components for conditionally rendering drag/drop wrappers
 * Allows us to conditionally call hooks while not instantiating a bunch
 * of extra state/etc., since draggable columns isn't yet(?) a default
 */

export var ConditionalDroppableColumns = /*#__PURE__*/memo(function (_ref7) {
  var canDragAndDropColumns = _ref7.canDragAndDropColumns,
    children = _ref7.children,
    rest = _objectWithoutProperties(_ref7, _excluded2);
  return canDragAndDropColumns ? ___EmotionJSX(DroppableColumns, rest, children) : ___EmotionJSX(React.Fragment, null, children);
});
ConditionalDroppableColumns.propTypes = {
  canDragAndDropColumns: PropTypes.bool.isRequired
};
ConditionalDroppableColumns.displayName = 'ConditionalDroppableColumns';
export var ConditionalDraggableColumn = /*#__PURE__*/memo(function (_ref8) {
  var canDragAndDropColumns = _ref8.canDragAndDropColumns,
    children = _ref8.children,
    rest = _objectWithoutProperties(_ref8, _excluded3);
  return canDragAndDropColumns ? ___EmotionJSX(DraggableColumn, rest, children) : ___EmotionJSX(React.Fragment, null, children());
});
ConditionalDraggableColumn.propTypes = {
  canDragAndDropColumns: PropTypes.bool.isRequired
};
ConditionalDraggableColumn.displayName = 'ConditionalDraggableColumn';

/**
 * Creates an invisible overlay that prevents hover interactions/transitions
 * on other elements that the dragged element is dragged over, and also maintains
 * the intended drag cursor over any location.
 *
 * TODO: If this is useful elsewhere, consider moving it to `src/services`
 */
export var DragOverlay = memo(({
  isDragging,
  cursor,
  zIndex = 9999
}) => {
  return isDragging ? <EuiPortal>
      <div css={{
      position: 'fixed',
      inset: 0
    }} style={{
      cursor,
      zIndex
    }} />
    </EuiPortal> : null;
});
DragOverlay.propTypes = {
  isDragging: PropTypes.bool,
  cursor: PropTypes.any,
  zIndex: PropTypes.any
};
DragOverlay.displayName = 'DragOverlay';
try {
  DroppableColumns.__docgenInfo = {
    tags: {},
    filePath: '/app/packages/eui/src/components/datagrid/body/header/draggable_columns.tsx',
    description: 'Parent context + EuiDroppable wrapper',
    displayName: 'DroppableColumns',
    methods: [],
    props: {
      columns: {
        defaultValue: null,
        description: '',
        name: 'columns',
        parent: {
          fileName: 'eui/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridHeaderRowPropsSpecificProps'
        },
        declarations: [{
          fileName: 'eui/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridHeaderRowPropsSpecificProps'
        }],
        required: true,
        type: {
          name: 'EuiDataGridColumn[]'
        }
      },
      switchColumnPos: {
        defaultValue: null,
        description: '',
        name: 'switchColumnPos',
        parent: {
          fileName: 'eui/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridHeaderRowPropsSpecificProps'
        },
        declarations: [{
          fileName: 'eui/src/components/datagrid/data_grid_types.ts',
          name: 'EuiDataGridHeaderRowPropsSpecificProps'
        }],
        required: true,
        type: {
          name: '(colFromId: string, colToId: string) => void'
        }
      },
      indexOffset: {
        defaultValue: null,
        description: '',
        name: 'indexOffset',
        parent: undefined,
        declarations: [{
          fileName: 'eui/src/components/datagrid/body/header/draggable_columns.tsx',
          name: 'TypeLiteral'
        }],
        required: true,
        type: {
          name: 'number'
        }
      }
    },
    extendedInterfaces: ['EuiDataGridHeaderRowPropsSpecificProps']
  };
} catch (e) {}